// 系统相关配置

let conf = {
  companyName: '石家庄平步科技有限公司',
  companyShortName: '平步科技',
  appName: '梦桥从业人员健康管理系统',
  apiBaseUrl: 'http://jianguan.jiankangzheng.com.cn/backapi-center',
  //apiBaseUrl: 'http://jianguan.jiankangzheng.com.cn/backapi-center-test',
  // apiBaseUrl: 'http://localhost:8981/backapi-center',
  global_set:{
    static_source_root_url : 'https://tijian.jiankangzheng.com.cn',
    permissionList: [{label:'系统管理员',value:'system_manager'},{label:'大屏首页',value:'daping_index'},
      {label:'大屏健康证列表',value:'daping_jiankangzheng'},
      {label:'大屏异常健康证',value:'daping_yichang_jiankangzheng'},{label:'大屏到期预警',value:'daping_daoqi_yujing'},
      {label:'大屏体检中心健康证统计',value:'daping_tijianzhongxin_jiankangzheng_tongji'},
      {label:'大屏单位健康证统计',value:'daping_dawei_jiankangzheng_tongji'},
      {label:'大屏体检中心年统计',value:'daping_tijian_zhongxin_niantongji'},
      {label:'大屏单位年统计',value:'daping_danwei_niantongji'},{label:'大屏体检中心',value:'daping_tijian_zhongxin'}],

  },
};

if (process.env.NODE_ENV === undefined || process.env.NODE_ENV === 'development'){

} else if (process.env.NODE_ENV === 'production'){

}

module.exports = conf;



// WEBPACK FOOTER //
// ./src/settings.js